import styled from 'styled-components';

import { size } from '../layout/helpers';

export const Image = styled.img`
  display: block;
  width: ${size(5)};
  height: ${size(5)};
  border-radius: 50%;
  object-fit: cover;
  background-color: var(--bg-accent, ${(props) => props.theme.color.accent});
`;
